export default "<app-loading *ngIf=\"loading\"></app-loading>\r\n<ng2-smart-table [settings]=\"settings\" [source]=\"examQuestionList\">\r\n</ng2-smart-table>";